require([
    "cart/cartOperations",
    "common/alertMessage",
    "common/spinner"
],
    function (cartOperations, alertMessage, spinner) {
        configuratorCarousel = null;
        editConfigurationsCarousel = null;
        elements = "";
        STATUS_OK = "OK";
        selectedData = {};      
        tmpOptionElement = null;
        categoryHtml = "";
        executedOnce = false;
        firstElement = null;
        currencyFormatter = null;
        discountFormatter = null;
        PLACEHOLDER_SUBCATEGORY = "{placeholderForSubcategory}";        
        TABLE_TAGS = { TABLE_END: "</table>", TR_END: "</tr>", TD_END: "</td>" };
        optionsList = [];
        openedTab = false;
        clickOptionElements = [];
        initClickOptions = [];
        initiated = false;
        validQuoteData = false;
        thumbImages = [];
        substitutedCategories = [];
        newlyAddedCategory = "";
        SAVE_CONFIGURATION_SPINNER = ".save-configuration-spinner";
        TOTAL_AMOUNT_SELECTOR = ".totalAmount";
        SAVE_CONFIGURATION_BUTTON_SELECTOR = ".saveConfiguration";
        
        function initConfigurator() {
            currencyFormatter = new Intl.NumberFormat(configurator.CurrencyInfo.CurrencyCulture, {
                style: 'currency',
                currency: configurator.CurrencyInfo.IsoCurrencyCode,
            });

            discountFormatter = new Intl.NumberFormat(configurator.CurrencyInfo.CurrencyCulture, {
                style: 'currency',
                currency: configurator.CurrencyInfo.IsoCurrencyCode,
                currencySign: 'accounting',
                signDisplay: 'always'
            });

            var frm = configurator.ConfigurationForms[0];
            setConfigurationForm(frm, true);
            updatePrices();
            triggerChangeEvents($('#accordionConfiguration'));
            $("#configurationSlide").show();
            $(SAVE_CONFIGURATION_BUTTON_SELECTOR).off("click").on("click", saveConfiguration);
            initiated = true;
            initTooltips();
        }

        function getProductOptionByProductNumber(productNumber) {
            return productOptions.find((e) => e.PartNumber == productNumber);
        }
               
        function dispatchOptionChangedEvent() {
            var configuratorElement = $("#configuratorCarousel");
            var selectedOptions = [];
            $('input[type=radio]:checked, input[type=checkbox]:checked', configuratorElement).each(function () {
                var selectedOption = $(this).data('productNumber');
                if (selectedOption) {
                    var elementId = this.id.substring(3);
                    var thumbUrlObj = thumbImages.find((x) => x.ImageId == elementId);
                    var thumbUrl = "";
                    var fullSizeImageUrl = "";
                    if (thumbUrlObj) {
                        thumbUrl = thumbUrlObj.Url;
                        fullSizeImageUrl = thumbUrlObj.FullSizeUrl;
                    }
                    selectedOptions.push({ "ProductCode": selectedOption, "Title": $('label[for="' + this.id + '"]').html(), "Image": thumbUrl, "FullSizeImage": fullSizeImageUrl });
                }
            });

            const productOptionChangedEvent = new CustomEvent("productOptionChanged", {
                detail: { selected : selectedOptions },
                bubbles: true,
                cancelable: true,
                composed: false,
            });
            document.dispatchEvent(productOptionChangedEvent);
        }

        function triggerChangeEvents(element) {
            $(element).trigger("change");
            $('input[type=radio]:checked', element).each(function () { clickOptionElements = []; triggerChangeEvents($(this)); });
            $('input[type=checkbox]:checked', element).each(function () { clickOptionElements = []; triggerChangeEvents($(this)); });
        }

        function getConfigurationForm() {
            if (selectedData.SelectedForm) return selectedData.SelectedForm;
            for (var i = 0; i < configurator.ConfigurationForms.length; i++) {
                var frm = configurator.ConfigurationForms[i];
                if (frm.SystemId == selectedData.SelectedSystem.Id && frm.ItemId == selectedData.SelectedProductItem.Id)
                    return frm;                
            }
            return null;
        }

        function createCategoryAccordionItem(category, openedTabs, openAllTabs) {
            categoryHtml = "";
            executedOnce = false;
            createCategoryOptions(category, category, 2, false);
            clearSubcategoryPlaceholder();
            addToElementsHtml(category, null);
        }

        function appendCategoryAccordionItem(accordionItemBeforeNewAccordionItem, category) {
            categoryHtml = "";
            executedOnce = false;
            createCategoryOptions(category, category, 2, true);
            clearSubcategoryPlaceholder();
            addToElementsHtml(category, accordionItemBeforeNewAccordionItem);
        }

        function clearSubcategoryPlaceholder() {
            if (categoryHtml.includes(PLACEHOLDER_SUBCATEGORY))
                categoryHtml = categoryHtml.replaceAll(PLACEHOLDER_SUBCATEGORY, "");
        }

        function addToElementsHtml(category, beforeElementToAdd) {
            openedTab = false;
            isOpenTab(category, 0);
            // this is for expanding all accordion items by default
            // comment this line if you don't want to expand all by default
            openedTab = true;
            var show = openedTab ? "show" : "";
            var collapsed = openedTab ? "" : " collapsed";
            var classname = "";
            var validationMessage = "";
            if (category.Message != null)
                validationMessage = 'data-validation-msg="' + category.Message + '"';

            if (category.IsError)
                classname = ' error-category';

            var accordionItemHtml = '<div class="accordion-item" id="accordionItem' + category.HtmlId + '">' +
                '<h2 class="accordion-header" id="heading' + category.HtmlId + '">' +
                '<button class="accordion-button' + collapsed + classname + '" type="button" data-bs-toggle="collapse" data-bs-target="#collapse' + category.HtmlId + '" aria-expanded="true" aria-controls="collapse' + category.HtmlId + '" data-error-message-for="' + category.Name + '">' + category.Name +
                '</button>' +
                '</h2>' +
                '<div id="collapse' + category.HtmlId + '" class="accordion-collapse collapse ' + show + '" aria-labelledby="heading' + category.HtmlId + '">' +
                '<div class="accordion-body" data-category-id="' + category.HtmlId + '"' + validationMessage + '>' +
                categoryHtml +
                '</div>' +
                '</div>' +
                '</div>';

            if (beforeElementToAdd == null)
                elements += accordionItemHtml;
            else
                $(beforeElementToAdd).after(accordionItemHtml);
        }

        function createCategoryOptions(parentElement, element, displayingLevel, skipElementLevelCheck) {
            var elementLevelCheck = true;
            if (skipElementLevelCheck) elementLevelCheck = false;
            if (!element) return;
            if (displayingLevel > 10) return;
            if (elementLevelCheck) {
                if (element.Level > displayingLevel) return;
            }
            if (parentElement == element && element.Options.length == 0) return;
            createCategoryTable(parentElement, element);
            //display only options (level one are handled already as categories or form options without category)
            if (parentElement != element) {
                if (element.Level > 1) {
                    if (parentElement.ConfigurationElementType == "Option" && element.ConfigurationElementType == "Category") {
                        categoryHtml = categoryHtml.replace(PLACEHOLDER_SUBCATEGORY, '<tr class="subcategoryTitle data-level-' + displayingLevel + '" data-subcategory-id="' + element.HtmlId + '" data-linked-category="true" data-requires-child="' + element.RequiresChild + '" data-element-id="' + element.HtmlId + '" data-hierarchy="' + element.Hierarchy + '" data-level="' + element.Level + '"><td class="subcategory-title">' + element.Name + "</td></tr>");
                        displayingLevel++;
                    }
                    else
                        createHtmlOption(parentElement, element);
                }
            }

            if (element.ConfigurationElementType == "Category" && element.RequiresChild == false && element.AllowMultiple == false)
                createNoneOption(element);

            if (element.Options && element.Options.length > 0) {
                for (var i = 0; i < element.Options.length; i++)
                    createCategoryOptions(element, element.Options[i], displayingLevel, skipElementLevelCheck);
            }

            if (firstElement == element) closeCategoryTableTag();
        }

        //check category elements, only on initialization
        function isOpenTab(element, level) {
            if (level > 1) return;
            if (level == 0) {
                if (element.RequiresChild) {
                    openedTab = true;
                    return;
                }
            }

            if (element.Options && element.Options.length > 0) {
                level++;
                if (element.Options.length > 0) {
                    var selectedOption = element.Options.some(x => x.IsSelected);
                    if (selectedOption) {
                        openedTab = true;
                        return;
                    }
                    for (var i = 0; i < element.Options.length; i++)
                        isOpenTab(element.Options[i], level);
                }
            }
        }

        function createNoneOption(element) {
            var options = "";
            var optionType = "radio";
            var overridableMessage = element.Message == null ? "" : 'data-overridable-message="' + element.Message + '"';
            var mainCategoryId = element.MainCategoryId;
            if (!mainCategoryId) mainCategoryId = element.HtmlId;
            var name = "radio_" + element.HtmlId + "_" + mainCategoryId;
            var id = generateElementId(element);
            options = '<tr class="data-level-' + (element.Level + 1) + '" id="rowOpt' + element.ParentHtmlId + "element" + element.HtmlId + '" data-row-parent-id="' + element.HtmlId + '" data-level="' + (element.Level + 1) + '" data-requires-child="' + element.RequiresChild + '">';
            var selected = 'checked="checked"';
            options += '<td class="descriptionColumn"><input onchange="clickOption(this);" type="' + optionType + '" id="noneopt' + id + '" name="' + name + '" data-level="' + (element.Level + 1) + '" data-category-id="' + mainCategoryId + '" data-none-option="true" data-parent-id="' + element.HtmlId + '" data-overridable="' + element.Overridable + '"' + overridableMessage + ' value="' + element.ProductId + '" ' + selected + '><label for="noneopt' + id + '">None</label></td>';
            var quantity = "&nbsp;";
            options += '<td class="paddingLeft">' + quantity + '</td>';
            var priceValue = "&nbsp;";
            var priceCell = '<td class="paddingLeft">' + priceValue + "</td>";
            options += priceCell;
            options += "</tr>";
            categoryHtml += options;
        }

        function createFormOptionsOnLevelOne(parentElement, element, displayingLevel) {
            if (!element) return;
            if (displayingLevel > 10) return;
            if (element.Level > displayingLevel) return;
            if (element.Level == 1) {
                var existingElement = getExistingHtmlElement(parentElement, element);
                if (existingElement.HtmlElement == null || (existingElement.HtmlElement != null && existingElement.SameLevel)) {
                    if (parentElement.ConfigurationElementType == "Option" && element.ConfigurationElementType == "Category") {
                        categoryHtml = categoryHtml.replace(PLACEHOLDER_SUBCATEGORY, '<tr class="subcategoryTitle data-level-' + element.Level + '" data-linked-category="true" data-requires-child="' + element.RequiresChild + '" data-hierarchy="' + element.Hierarchy + '" data-level="' + element.Level + '"><td>' + element.Name + "</td></tr>");
                        displayingLevel++;
                    }
                    else
                        createHtmlOption(parentElement, element);
                }

                if (existingElement.HtmlElement != null && existingElement.SameLevel == false) {
                    categoryHtml += "";
                    return;
                }
            }

            if (element.Options && element.Options.length > 0) {
                for (var i = 0; i < element.Options.length; i++)
                    createCategoryOptions(element, element.Options[i], displayingLevel, skipElementLevelCheck);
            }
        }

        function closeCategoryTableTag() {
            if (categoryHtml.indexOf("<table") > -1)
                categoryHtml += TABLE_TAGS.TABLE_END;
            if (categoryHtml.includes(PLACEHOLDER_SUBCATEGORY))
                categoryHtml = categoryHtml.replace(PLACEHOLDER_SUBCATEGORY, "");
        }

        function createCategoryTable(parentElement, element) {
            if (!executedOnce) {
                categoryHtml += '<table id="optTable' + parentElement.HtmlId + "element" + element.HtmlId + '" data-element-type="' + element.ConfigurationElementType + '" data-level="' + parentElement.Level + '" data-table-name="' + parentElement.Name + '" data-parent-id="' + parentElement.HtmlId + '" data-requires-child="' + element.RequiresChild + '" data-element-id="' + element.HtmlId + '" class="tblProducts">';
                executedOnce = true;
                firstElement = element;
            }
            categoryHtml += PLACEHOLDER_SUBCATEGORY;
        }

        function createHtmlOption(parentElement, element) {
            var options = "";
            var elementType = "";
            if (parentElement.AllowMultiple)
                elementType = "checkbox";
            else if (parentElement.ConfigurationElementType == "Category")
                elementType = "radio";
            else
                elementType = "checkbox";
            options = createOption(element, elementType);
            categoryHtml += options;
        }

        function createOption(element, optionType) {
            var validationMessage = element.Message == null ? "" : 'data-validation-msg="' + element.Message + '"';
            var options = "";
            var name = optionType == "checkbox" ? element.HtmlId : "radio_" + element.ParentHtmlId + "_" + element.MainCategoryId;
            options = '<tr class="data-level-' + element.Level + '" id="rowOpt' + element.ParentHtmlId + "element" + element.HtmlId + '" data-row-parent-id="' + element.ParentHtmlId + '"' + '" data-element-type="' + element.ConfigurationElementType + '" data-level="' + element.Level + '" data-requires-child="' + element.RequiresChild + '" data-element-id="' + element.HtmlId + '" data-hierarchy="' + element.Hierarchy + '">';
            var selected = element.IsSelected ? 'checked="checked"' : "";
            var id = generateElementId(element);
            options += '<td class="descriptionColumn"><input onchange="clickOption(this);" type="' + optionType + '" id="opt' + id + '" name="' + name + '" data-level="' + element.Level + '" data-category-id="' + element.MainCategoryId + '"' + validationMessage + ' data-parent-id="' + element.ParentHtmlId + '" data-default-unit="' + element.DefaultUnit + '" data-element-hierarchy="' + element.Hierarchy + '" value="' + element.ProductId + '" ' + selected + ' data-relationship-id="' + element.ProductRelationshipId + '" data-product-number="' + element.ProductNumber + '"><label for="opt' + id + '">' + element.Name + '</label></td>';

            var productOption = getProductOptionByProductNumber(element.ProductNumber);

            if (productOption) {
                var tooltipImg = "";
                if (productOption.ListingImage) {
                    tooltipImg = '<div class="tooltip-image-wrapper"><img id="img' + id + '" class="tooltip-image" src="' + productOption.ListingImage + '"></div>';
                    thumbImages.push({ "ImageId": id, "Url": productOption.ListingImage, "FullSizeUrl": productOption.ListingImageFullSize });
                }
                var tooltipContent = '<div class="tooltip-content"><div class="tooltip-title"><p>' + productOption.PartName + '</p></div>' +
                    '<div class="tooltip-grid">' + tooltipImg + '<div class="tooltip-description">' + productOption.Description + '</div></div></div></div>';

                var htmlEncodeTooltip = escapeHtml(tooltipContent);
                var infoIcon = '<td class=""><i data-bs-toggle="tooltip" data-bs-html="true" data-bs-title="' + htmlEncodeTooltip + '" class="fa fa-info-circle config-info-icon">' + '</i></td>';
                options += infoIcon;
            }
            var quantityValue = element.Quantity == 1 || element.Quantity == 0 ? "" : element.Quantity;
            if (element.IsSelected) {
                if (element.Quantity != 0)
                    quantityValue = element.Quantity;
            }
            var quantity = element.FixedQuantity ? '<span id="qnt' + id + '">' + quantityValue + '</span>' : '<input id="qnt' + id + '" class="configurator-option-quantity" disabled="disabled" type="number" min="1" onkeyup="updatePrices();" onmouseup="updatePrices();" value="' + quantityValue + '" />';
            options += '<td class="paddingLeft">' + quantity + '</td>';
            var priceValue = "&nbsp;";
            if (element.Price != 0) priceValue = currencyFormatter.format(element.Price);
            var priceCell = '<td class="paddingLeft">' + priceValue + '<input type="hidden" id="price' + id + '" value="' + element.Price + '"></td>';
            if (displayPrices == 'True')
                options += priceCell;
            options += "</tr>";

            var optionElement = { OptionId: "opt" + generateElementId(element), Level: element.Level, CategoryId: element.MainCategoryId, HtmlId: element.HtmlId, ParentId: element.ParentHtmlId, Element: element };
            optionsList.push(optionElement);
            var existingElement = clickOptionElements.find(x => x.OptionId == optionElement.OptionId);

            if (!existingElement)
                clickOptionElements.push(optionElement);

            return options;
        }

        function escapeHtml(unsafe) {
            return unsafe
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#039;");
        }

        function generateElementId(element) {
            return element.ParentHtmlId + "element" + element.HtmlId + 'category' + element.MainCategoryId;
        }

        function getElementObjectFromHtml(htmlElement) {
            var optionId = $(htmlElement).attr('id');
            var parentId = $(htmlElement).data('parentId');
            var level = $(htmlElement).data('level');
            var categoryId = $(htmlElement).data('categoryId');
            var rowOptId = optionId.replace(new RegExp(categoryId + '$'), '');
            rowOptId = rowOptId.replace("opt", "").replace("none", "").replace("category", "");
            optionId = optionId.replace(parentId, "").replace("opt", "").replace("element", "").replace(categoryId, "").replace("category", "");
            var hierarchy = $(htmlElement).data('elementHierarchy');
            getFormElementByProductHtmlId(optionId, parentId, level, categoryId, hierarchy);
            return { "OptionId": optionId, "ParentId": parentId, "CategoryId": categoryId, "RowOptId": rowOptId }
        }

        clickOption = function (htmlElement) {                
            enableOrDisableQuantityTextbox(htmlElement);
            var elementProperties = getElementObjectFromHtml(htmlElement);
            var currentOptionElement = tmpOptionElement;
            var parentElement = $(htmlElement).closest("tbody").find('[data-element-hierarchy="' + $(htmlElement).data("elementHierarchy") + '"]');
            if (parentElement.length == 0)
                parentElement = $(htmlElement).closest("tbody").find('input[id^="opt"]');   
            removePreviousSelect(htmlElement, parentElement);           
            handleOption(htmlElement, currentOptionElement, elementProperties.OptionId);
            updatePrices();
            dispatchOptionChangedEvent();
            initTooltips();
        }

        unselect = function (htmlElement) {            
            enableOrDisableQuantityTextbox(htmlElement);
            var elementProperties = getElementObjectFromHtml(htmlElement);
            var currentOptionElement = tmpOptionElement;
            var parentElement = $(htmlElement).closest("tbody").find('[data-element-hierarchy="' + $(htmlElement).data("elementHierarchy") + '"]');
            if (parentElement.length == 0)
                parentElement = $(htmlElement).closest("tbody").find('input[id^="opt"]');          
            handleOption(htmlElement, currentOptionElement, elementProperties.OptionId);
            updatePrices();
            dispatchOptionChangedEvent();
            initTooltips();
        }

        function removePreviousSelect(htmlElement, parentElement) {            
            $(parentElement).each(function () {
                var parent = $(this);
                $(this).closest("table").find('[data-element-hierarchy^="' + $(this).data("elementHierarchy") + "|" + $(this).val().replaceAll("_", "-") + '"]').each(function () {
                    if ($(htmlElement).attr("id") != $(parent).attr("id") && !$(parent).is(":checked")) {
                        if ($(this).is(':checked')) {
                            $(this).prop("checked", false);
                            unselect($(this));
                        }
                    }
                    if (!parent.is(":checked"))
                        $(this).closest("tr").remove();
                });
            });

            if (initiated) {
                $(parentElement).each(function () {

                    if ($(this).attr("id") != $(htmlElement).attr("id")) {
                        if ($(this).is(":checked") == false) {
                            $(this).prop("checked", false);
                            unselect($(this));
                        }
                    }
                });
            }
        }

        function initTooltips() {
            const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]')
            const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))
        }

        function enableOrDisableQuantityTextbox(htmlElement) {
            var trElement = $(htmlElement).closest("tr");
            var quantityTxt = $(trElement).find('input[type="number"][id^="qnt"]');
            if (quantityTxt && quantityTxt.length) {
                if ($(htmlElement).is(':checked')) {
                    $(quantityTxt).prop('disabled', false);
                } else {
                    $(quantityTxt).prop('disabled', true);
                }
            }
        }

        function saveConfiguration(event) {          
            validateForm();
            validateData();                       
            var totalAmountPriceVal = 0;
            var totalAmountPriceElement = $(TOTAL_AMOUNT_SELECTOR).find(".totalAmountPrice");
            if (totalAmountPriceElement)
                totalAmountPriceVal = $(totalAmountPriceElement).data("totalPrice");           
            if (totalAmountPriceVal == 0) {
                alertMessage.warning($(TOTAL_AMOUNT_SELECTOR).data("noComponentsSelectedText"));
                return;
            }
            if (!validQuoteData) return;
            spinner.show(SAVE_CONFIGURATION_SPINNER);
            $(this).prop("disabled", true);
            var cartItemId = $(event.target).data("cartItemId");
            addOrUpdateCart(cartItemId);            
        }

        function validateData() {            
            validQuoteData = true;
            var configuratorElement = $("#configuratorCarousel");
            $('input[type=radio]:checked:visible, input[type=checkbox]:checked:visible', configuratorElement).each(function () {
                if ($(this).attr("id").indexOf("noneopt") != -1) return;
                var htmlElement = $(this);
                getElementObjectFromHtml(htmlElement);
                var currentOptionElement = tmpOptionElement;                
                validateSubOptions(htmlElement, currentOptionElement);
            });
        }

        function validateSubOptions(htmlElement, element) {
            if (!element) return;
            var validElement = false;
            if (element.Options && element.Options.length) {
                for (var i = 0; i < element.Options.length; i++) {
                    var option = element.Options[i];
                    var optionHtmlElement = $('input[id*="element' + option.HtmlId + '"]:checked:visible');
                    if (element.RequiresChild) {
                        if (!validElement) {                            
                            if (optionHtmlElement && optionHtmlElement.length) {
                                validElement = true;
                            }
                        }
                    }
                    else
                        validElement = true;
                    // validate only suboptions if option is checked
                    if (optionHtmlElement && optionHtmlElement.length)
                        validateSubOptions(htmlElement, option);
                    // validate if option has category as suboption
                    if (element.Options.length == 1 && option.ConfigurationElementType == "Category")
                        validateSubOptions(htmlElement, option);
                }
            }
            else
                validElement = true;

            if (!validElement) {                
                validQuoteData = false;
                var accordionItem = $(htmlElement).closest(".accordion-item");
                var messageTxt = element.Message ? element.Message : "Your configuration is missing " + element.Name + " Option(" + $(htmlElement).data("productNumber") + ")";
                $(accordionItem).find(".accordion-button").css("background-color", "red");               
                $("#errors").append('<p id="error' + $(accordionItem).attr("id") + '"><a href="#' + $(accordionItem).attr("id") + '">' + messageTxt + "</a></p>");
                var errors = $("#errors").find("p");
                errors.length ? $("#errors").show() : $("#errors").hide();
                errors.length ? $(SAVE_CONFIGURATION_BUTTON_SELECTOR).prop("disabled", true) : $(SAVE_CONFIGURATION_BUTTON_SELECTOR).prop("disabled", false); 
                return;
            }
        }

        function addOrUpdateCart(cartItemId) {
            var confDetails = getConfigurationDetails();
            var productNumber = productItemInfo.ProductNumber;
            var confQuantity = $("#configurationQuantity").val();
            if (cartItemId) {
                // updating an existing cart item
                cartOperations.updateCartItem(
                    cartItemId,
                    productNumber,
                    confQuantity,
                    confDetails,
                    cartOperationCallback,
                    cartOperationErrorCallback
                );
            }
            else
            {
                // adding a new item to the cart
                cartOperations.addItemToCart(
                    productNumber,
                    confQuantity,
                    null,             // Notes
                    confDetails,
                    cartOperationCallback,
                    cartOperationErrorCallback
                );
            }
        }

        function getConfigurationDetails() {
            var quoteDetails = getQuoteDetails();
            return quoteDetails.map(({ ProductNumber, Quantity, CategoryId }) => ({ DetailCode: ProductNumber, Quantity: Quantity, CategoryId : CategoryId }));
        }

        function cartOperationCallback() {
            window.location = "/cart";
        }

        function cartOperationErrorCallback() {
            $(SAVE_CONFIGURATION_BUTTON_SELECTOR).prop("disabled", false);
            spinner.hide(SAVE_CONFIGURATION_SPINNER);
        }

        function editQuoteDetails() {
            var quoteDetails = getQuoteDetails();
            var quoteDetailsInfo = { "LynxItemId": selectedData.SelectedProductItem.LynxItemId, "QuoteDetails": quoteDetails, "ProductItemName": selectedData.SelectedProductItem.Text, "ProductItemId": selectedData.SelectedProductItem.Id, "ProductNumber": selectedData.SelectedProductItem.ProductNumber, "ConfigurationQuantity": $("#configurationQuantity").val() };
            var data = { "QuoteId": selectedData.QuoteId, "ConfigurationNumber": selectedData.SelectedConfigurationNumber, "QuoteDetailsInfo": quoteDetailsInfo, "AddNewConfiguration": selectedData.AddNewConfiguration };
            ajaxCall("/Configurator/EditQuoteConfiguration", data, null, function (response) {
                if (response && response.status == STATUS_OK) {
                    alert("Changes saved");
                    document.getElementById("configuratorCarousel").style.display = "none";
                    document.getElementById("editConfigurationsCarousel").style.display = "block";
                    if (selectedData.IsInEditingMode && selectedData.AddNewConfiguration)
                        goToEditQuotes();
                    else
                        editConfigurationsCarousel.to(1);
                }
                else
                    alert("Error occured. Data not saved.");
            }, function (response) {
                alert(response.message);
            });
        }

        function createQuoteWithDetails() {              
            var quoteDetails = getQuoteDetails();
            ajaxCall("/customapi/Configurator/CreateQuoteWithDetails", { "LynxItemId": productItemInfo.LynxItemId, "QuoteDetails": quoteDetails, "ProductItemName": productItemInfo.Name, "ProductItemId": productItemInfo.ProductId, "ProductNumber": productItemInfo.ProductNumber, "ConfigurationQuantity": $("#configurationQuantity").val() }, null, function (response) {
                if (response && response.Data && response.status == STATUS_OK) {
                    alert("Configuration created.");
                }
                else
                    alert("Error occured. Data not saved.");
            }, function (response) {
                alert(response.message);
            });
        }

        function getQuoteDetails() {
            var quoteDetails = [];
            $("#configurationPanel .accordion-item").each(function () {
                var checkedOptions = $(this).find('[id^="opt"]:checked');
                addQuoteDetails(quoteDetails, checkedOptions);
            });
            var checkedOptions = $('.formOptionsList').find('[id^="opt"]:checked');
            addQuoteDetails(quoteDetails, checkedOptions);
            return quoteDetails;
        }

        function addQuoteDetails(quoteDetails, checkedOptions) {
            if (checkedOptions && checkedOptions.length) {
                for (var i = 0; i < checkedOptions.length; i++) {
                    var checkedOption = checkedOptions[i];
                    var id = $(checkedOption).attr("id").replace("opt", "");
                    var trElement = $(checkedOption).closest("tr");
                    var quantityElement = $(trElement).find("#qnt" + id);
                    var quantity = 1;
                    if (quantityElement.val() != "")
                        quantity = parseFloat(quantityElement.val());
                    var priceElement = $(trElement).find("#price" + id);
                    var price = 0;
                    if (priceElement.val() != "")
                        price = parseFloat(priceElement.val());
                    quoteDetails.push({ "QuoteId": null, "ProductId": $(checkedOption).val(), "ProductNumber": $(checkedOption).data("productNumber"), "Quantity": quantity, "DefaultUnit": $(checkedOption).data("defaultUnit"), "ParentProductId": $(checkedOption).data("parentId"), "Price": price, "CategoryId": $(checkedOption).data("categoryId"), "Hierarchy": $(checkedOption).data("elementHierarchy"), "ProductName": $('label[for="' + $(checkedOption).attr("id") + '"]').html() });
                }
            }
        }

        function validateForm() {
            $('[data-validation-msg]').each(function () {
                var accordionItem = $(this).closest(".accordion-item");
                if ($(accordionItem).css('display') == 'none') return;
                var accordionBody = $(accordionItem).find(".accordion-collapse");
                if (hasRequiredFields(this)) {
                    $(accordionItem).find(".accordion-button").css("background-color", "");
                    $(accordionBody).find(".validationMessage").remove();
                    $("#errors").find('[id="error' + $(accordionItem).attr("id") + '"]').remove();
                }
                else {
                    if (!$(accordionBody).find(".validationMessage").length) {
                        $(accordionItem).find(".accordion-button").css("background-color", "red");
                        var validationText = $(this).data("validationMsg");
                        var messageElement = '<div class="validationMessage">' + validationText + "</div>";
                        $(accordionBody).prepend(messageElement);
                        $("#errors").append('<p id="error' + $(accordionItem).attr("id") + '"><a href="#' + $(accordionItem).attr("id") + '">' + validationText + "</a></p>");
                    }
                }
            });

            validateRequiredSubcategories();
            validateFieldsWithoutValidationMessage();
            var errors = $("#errors").find("p");
            errors.length ? $("#errors").show() : $("#errors").hide();
            errors.length ? $(SAVE_CONFIGURATION_BUTTON_SELECTOR).prop("disabled", true) : $(SAVE_CONFIGURATION_BUTTON_SELECTOR).prop("disabled", false);
        }

        function validateFieldsWithoutValidationMessage() {
            $('[data-requires-child="true"]:not([data-linked-category="true"])').each(function () {
                var accordionItem = $(this).closest(".accordion-item");
                if ($(accordionItem).css('display') == 'none') return;
                var categoryBackgroundColor = $(accordionItem).find(".accordion-button").css("background-color");
                var checkedElements = $(this).find(":input:checked");
                if (checkedElements.length == 0) {
                    if (categoryBackgroundColor != "red") {
                        $(accordionItem).find(".accordion-button").css("background-color", "red");
                        var errorsContent = $("#errors").html();
                        if (errorsContent.indexOf("#" + $(accordionItem).attr("id")) == -1)
                            $("#errors").append('<p id="error' + $(accordionItem).attr("id") + '"><a href="#' + $(accordionItem).attr("id") + '">Select one option (required)</a></p>');
                    }
                }
                else {
                    $("#errors").find('[id="error' + $(accordionItem).attr("id") + '"]').remove();
                    $(accordionItem).find(".accordion-button").css("background-color", "");
                }
            });
        }

        function getSubcategoryOptions(element) {
            var subcategoryId = $(element).data("subcategoryId");
            if (!subcategoryId) return null;
            var dataHierarchy = $(element).data("hierarchy");
            var subcategoryRows = $('tr[data-hierarchy="' + dataHierarchy + "|" + subcategoryId.replaceAll("_", "-") + '"][data-row-parent-id="' + subcategoryId + '"]');
            return subcategoryRows;
        }

        function validateRequiredSubcategories() {
            $('[data-validation-option="1"]').remove();
            $('[data-linked-category="true"][data-requires-child="true"]').each(function () {
                var subcategoryRows = getSubcategoryOptions(this);
                if (subcategoryRows.length) {
                    var checkedElements = $(subcategoryRows).find(":input:checked");
                    if (checkedElements && checkedElements.length > 0) {
                    }
                    else {
                        $(this).find("td").append('<div data-validation-option="1" class="text-warning">This option is required</div>');
                    }
                }
                else
                    $(this).hide();
            });
        }

        function hasRequiredFields(item) {
            if ($(item).hasClass("accordion-body")) {
                var checkedElements = $(item).find(":input:checked");
                if (checkedElements && checkedElements.length > 0) return true;
                return false;
            }
            else {
            }
        }

        function handleOption(htmlElement, currentOptionElement, optionId) {
            clickOptionElements = [];
            if (currentOptionElement) {
                categoryHtml = "";                
                createCategoryOptions(currentOptionElement, currentOptionElement, currentOptionElement.Level + 1, false);

                var trElement = $(htmlElement).closest("tr");
                $("#optionRow" + optionId).remove();
                $('[data-validation-option="1"]').remove();

                if ($(htmlElement).data("noneOption") != true) {
                    clearSubcategoryPlaceholder();
                    if ($(htmlElement).is(":checked"))
                        $(trElement).after(categoryHtml);                    
                }
                else
                    handleNoneOptionClick(htmlElement);

                hideEverySubcategory();
                setQuantityOnClick(htmlElement);
                handleOtherOptionsBasedOnRules(htmlElement);
                hideEveryDuplicateOption();  
                hideOptionsWithoutAnySuboption();
                triggerSelectedOptions(htmlElement);
                $('table[id*="optTable"][style*="display: none"]').each(function () { $(this).closest(".accordion-item").hide(); });
                validateForm();
            }
        }

        function handleOtherOptionsBasedOnRules(htmlElement) {           
            getElementObjectFromHtml(htmlElement);
            var elementOption = tmpOptionElement;
            var checked = $(htmlElement).is(':checked');
            if ($(htmlElement).attr("id").indexOf("noneopt") > -1)
                checked = false;

            newlyAddedCategory = "";
            for (var i = 0; i < elementOption.Options.length; i++) {
                iterateThroughOptionRules(elementOption, htmlElement, checked, elementOption.Options[i]);
            }
        }

        function iterateThroughOptionRules(elementOption, htmlElement, checked, option) {           
            if (option.ConfigurationElementType == "Category") {
                var hasSelectedOption = false;
                var defaultOption = null;
                var createdCategory = false;
                                                           
                for (var i = 0; i < option.Options.length; i++) {
                    var suboption = option.Options[i];
                    if (suboption.IsSelected == true)
                        defaultOption = suboption;
                    
                    if (option.RequiresChild == true) {
                        var suboptionHtml = $("#opt" + generateElementId(suboption));                        
                        var suboptionsOnForm = $('input[value="' + suboption.ProductId + '"]');
                        $(suboptionsOnForm).each(function () {
                            if ($(this).is(':checked')) 
                                hasSelectedOption = true;                            

                            if (checked) {
                                if ($(this).data("level") == 2) {                                   
                                        var category = getClosestTable($(this));
                                    if (category != null) {
                                        var accordionItem = $(category).closest(".accordion-item");
                                        if (checked) {
                                            setOptionLevels(option, 2);
                                            if (accordionItem.attr("id") != "accordionItem" + option.HtmlId) {
                                                var originalCategoryId = accordionItem.attr("id").replace("accordionItem", "");
                                                appendCategoryAccordionItem(accordionItem, option);
                                                $(accordionItem).remove();
                                                var substitutedCategory = substitutedCategories.find(x => x.OriginalCategoryId == originalCategoryId);
                                                if (!substitutedCategory) {
                                                    substitutedCategories.push({ "OriginalCategoryId": originalCategoryId, "SubstitutedCategoryId": option.HtmlId });
                                                }
                                                createdCategory = true;
                                            }
                                        }
                                    }                                   
                                }
                            }                           
                        });
                    }

                    if (!createdCategory) {
                        if (checked)
                            createCategoryOnHighestLevel(elementOption, htmlElement, option);
                    }

                    if (!checked) removeCategoryOnHighestLevel(elementOption, option);

                    iterateThroughOptionRules(elementOption, htmlElement, checked, option.Options[i]);
                }

                if (option.RequiresChild == true) {
                    if (!hasSelectedOption) {
                        if (checked) {
                            var suboptionHtml = $('input[value="' + defaultOption.ProductId + '"]');
                            $(suboptionHtml).prop('checked', true);
                        }
                    }
                }

            }
            //if it is option, don't go further, we are going recursevly only to options element type
            else if (option.ConfigurationElementType == "Option") {
                return;
            }
        }

        function removeCategoryOnHighestLevel(elementOption, option) {
            var substitutedCategory = substitutedCategories.find(x => x.SubstitutedCategoryId.indexOf(option.HtmlId) != -1);
            if (substitutedCategory) {
                substitutedCategory.SubstitutedCategoryId = substitutedCategory.SubstitutedCategoryId.replaceAll('|' + elementOption.HtmlId, '');
                if (substitutedCategory.SubstitutedCategoryId == option.HtmlId) {
                    var categoryElement = getAnyCategoryElementById(substitutedCategory.OriginalCategoryId);
                    if (categoryElement) {
                        var substitutedAccordion = $("#accordionItem" + substitutedCategory.SubstitutedCategoryId);
                        if (substitutedCategory.OriginalCategoryId != substitutedCategory.SubstitutedCategoryId)
                            appendCategoryAccordionItem(substitutedAccordion, categoryElement);
                        $(substitutedAccordion).remove();

                        substitutedCategories = substitutedCategories.filter(function (obj) {
                            return obj.SubstitutedCategoryId !== option.HtmlId;
                        });
                    }
                }
            }
        }

        function createCategoryOnHighestLevel(elementOption, htmlElement, option) {
            var existingCategoryItem = $("#accordionItem" + option.HtmlId);
            if (existingCategoryItem.length == 0) {
                setOptionLevels(option, 2);
                var table = getClosestTable($(htmlElement));
                if (table != null) {
                    var accordionItem = $(table).closest(".accordion-item");
                    if (newlyAddedCategory != "") {
                        existingCategoryItem = $("#accordionItem" + newlyAddedCategory);
                        if (existingCategoryItem.length > 0)
                            accordionItem = existingCategoryItem;
                    }
                    appendCategoryAccordionItem(accordionItem, option);
                    newlyAddedCategory = option.HtmlId;
                    var substitutedCategory = substitutedCategories.find(x => x.OriginalCategoryId == option.HtmlId);
                    if (!substitutedCategory) {
                        substitutedCategories.push({ "OriginalCategoryId": option.HtmlId, "SubstitutedCategoryId": option.HtmlId + '|' + elementOption.HtmlId });
                    }

                    checkIfNewlyAddedCategoryHasSubcategories(option.HtmlId);
                }
            }
            else {
                var substitutedCategory = substitutedCategories.find(x => x.OriginalCategoryId == option.HtmlId);
                if (substitutedCategory) {
                    substitutedCategory.SubstitutedCategoryId += '|' + elementOption.HtmlId;                    
                }
            }
            firstElement = null;
        }

        function checkIfNewlyAddedCategoryHasSubcategories(htmlId) {
            var categoryItem = $("#accordionItem" + htmlId);
            var subcategories = $(categoryItem).find('[data-linked-category="true"]');
            if (subcategories.length > 0) {
                var checkedOptions = $(categoryItem).find("input:checked").first();
                if (checkedOptions.length > 0)
                    triggerChangeEvents(checkedOptions);
            }
        }

        function getAnyCategoryElementById(elementId) {
            var selectedForm = getConfigurationForm();
            var elementWithId = null;
            for (var i = 0; i < selectedForm.Elements.length; i++) {
                var element = selectedForm.Elements[i];
                iterateThroughElementOptions(element, function (el) {
                    if (el.HtmlId == elementId)
                        elementWithId = el;
                });                
            }

            return elementWithId;
        }

        function iterateThroughElementOptions(element, customFunction) {
            if (!element) return;
            customFunction(element);
            for (var i = 0; i < element.Options.length; i++) {
                var el = element.Options[i];
                customFunction(el);
                iterateThroughElementOptions(el, customFunction);                
            }
        }

        function setOptionLevels(option, levelToSet) {
            option.Level = levelToSet;
            for (var i = 0; i < option.Options.length; i++) {
                setOptionLevels(option.Options[i], option.Level + 1);
            }
        }

        function getClosestTable(opt) {
            var table = $(opt).closest("table");
            if (table.length == 0) return null;
            return table;         
        }

        function triggerSelectedOptions(htmlElement) {
            if (!initiated) {
                var existingClick = initClickOptions.find(x => htmlElement.id);
                if (existingClick) return;
                initClickOptions.push(htmlElement);
            }
            else
                initClickOptions = [];
            for (var i = 0; i < clickOptionElements.length; i++) {
                var el = clickOptionElements[i].Element;
                if (el.IsSelected) {
                    $("#" + clickOptionElements[i].OptionId).each(function () { triggerChangeEvents($(this)); });
                }               
            }
        }

        //we will display subcategories always as categories, so hide them
        function hideEverySubcategory() {
            $('[data-linked-category="true"]').each(function () {                
                var subcategoryOptions = getSubcategoryOptions(this);
                if (subcategoryOptions) {
                    $(subcategoryOptions).remove();                   
                }
                $('[data-none-option="true"][data-parent-id="' + $(this).data("elementId") + '"]').closest("tr").remove();
                $(this).remove();
            });
        }

        function hideOptionsWithoutAnySuboption() {
            $('[data-linked-category="true"]').each(function () {
                var subcategoryOptions = getSubcategoryOptions(this);
                if (subcategoryOptions) {
                    var inputs = $(subcategoryOptions).find(":input:not([type=hidden]):visible");
                    if (inputs.length == 0) {
                        $(this).remove();
                    }
                }
            });
           
            $('[data-requires-child]:not([data-linked-category="true"]):visible').each(function () {
                var subcategoryContent = getSubcategoryOptions(this);
                if (subcategoryContent) {
                    var inputs = $(subcategoryContent).find(":input:not([type=hidden]):visible");
                    if (inputs.length == 0) {
                        $(subcategoryContent).hide();
                    }
                }
            });

            //hide accordion items if they have no options
            $(".accordion-item").each(function () {
                var inputs = $(this).find('tr:not([style*="display: none"])');
                if (!inputs.length) $(this).hide();
            });
        }

        function hideEveryDuplicateOption() {
            var duplicateOptions = [];
            var configuratorEl = $("#configuratorCarousel");
            $('input[id^="opt"]', configuratorEl).each(function () {
                duplicateOptions.push({ "element": $(this), "elementId": $(this).val(), "level": $(this).data("level") });
            });

            $('input[id^="noneopt"]', configuratorEl).each(function () {
                duplicateOptions.push({ "element": $(this), "elementId": $(this).val(), "level": $(this).data("level") });
            });

            var groupById = groupBy(duplicateOptions, "elementId");
            for (var key in groupById) {
                var options = groupById[key];
                if (options && options.length > 1) {
                    allHaveSameLevel = areAllDuplicateOptionsSameLevel(options);
                    //Allow duplicate options on same level, if we don't want to allow duplicate options on same level, comment the line below this comment
                    if (allHaveSameLevel) continue;
                    options = options.sort((a, b) => a.level - b.level);
                    for (var i = 1; i < options.length; i++) {
                        var option = options[i];
                        $(option.element).closest("tr").remove();
                    }
                }
            }
        }

        function areAllDuplicateOptionsSameLevel(options) {
            return options.every((element, index, arr) => element.level === arr[0].level);
        }

        function setQuantityOnClick(htmlElement) {
            var parent = $(htmlElement).closest("table");
            if (parent && parent.length) {
                $(parent).find("input").each(function () {
                    setQuantityOnElement($(this));
                });
            }
        }

        function setQuantityOnElement(htmlElement) {
            var id = $(htmlElement).attr("id").replace("opt", "");
            var quantityElement = $("#qnt" + id);
            var quantity = 1;
            if (quantityElement.val() != "")
                quantity = parseFloat(quantityElement.val());
            if (htmlElement.type === 'radio') {
                var parentElement = $(htmlElement).closest('table');
                if (parentElement && parentElement.length) {
                    $(parentElement).find('input').each(function () {
                        var id = $(this).attr("id").replace("opt", "");
                        $("#qnt" + id).text("");
                    });
                }
            }

            if ($(htmlElement).prop("checked")) {
                if ($(quantityElement).is("span"))
                    $(quantityElement).text(quantity);
                else
                    $(quantityElement).val(quantity);
            }
            else {
                if ($(quantityElement).is("span"))
                    $(quantityElement).text("");
                else
                    $(quantityElement).val("");
            }
        }

        updatePrices = function () {            
            $("#configuratorComponentsList").empty();
            var quoteDetails = getQuoteDetails();
            var subtotalAmount = 0;
            for (var i = 0; i < quoteDetails.length; i++) {
                var quoteDetail = quoteDetails[i];
                subtotalAmount += quoteDetail.Quantity * quoteDetail.Price;
                if (quoteDetail.Quantity > 1) {
                    if (displayPrices == 'True')
                        $("#configuratorComponentsList").append('<li><span class="configurator-summary-item-name">' + quoteDetail.Quantity + ' X ' + quoteDetail.ProductName + '</span><span class="configurator-summary-item-price">' + currencyFormatter.format(quoteDetail.Price) + '</span></li>');
                    else
                        $("#configuratorComponentsList").append('<li><span class="configurator-summary-item-name">' + quoteDetail.Quantity + ' X ' + quoteDetail.ProductName + '</span></li>');
                }
                else {
                    if (displayPrices == 'True')
                        $("#configuratorComponentsList").append('<li><span class="configurator-summary-item-name">' + quoteDetail.ProductName + '</span><span class="configurator-summary-item-price">' + currencyFormatter.format(quoteDetail.Price) + '</span></li>');
                    else
                        $("#configuratorComponentsList").append('<li><span class="configurator-summary-item-name">' + quoteDetail.ProductName + '</span></li>');
                }
            }

            if (subtotalAmount == 0)
                $("#summaryAccordion").find(".accordion-item").hide();
            else
                $("#summaryAccordion").find(".accordion-item").show();

            setSubtotalAmount(subtotalAmount);
            calculatePrices(subtotalAmount);

            //if (configurator.IsDiscountLineItem)
            //    $("#totalAmount").html('<span class="totalAmountText"></span><span data-total-price="' + subtotalAmount + '"" class="totalAmountPrice">' + currencyFormatter.format(subtotalAmount) + "</span>");
            //else {
            //    subtotalAmount = subtotalAmount - (subtotalAmount * configurator.DiscountPercentage / 100);
            //    $("#totalAmount").html('<span class="totalAmountText"></span><span data-total-price="' + subtotalAmount + '" class="totalAmountPrice">' + currencyFormatter.format(subtotalAmount) + "</span>");
            //}
        }
                
        function setSubtotalAmount(subtotalAmount) {
            $(TOTAL_AMOUNT_SELECTOR + " span").remove();
            $(TOTAL_AMOUNT_SELECTOR).append('<span class="totalAmountText"></span><span data-total-price="' + subtotalAmount + '"" class="totalAmountPrice">' + currencyFormatter.format(subtotalAmount) + "</span>");
        }

        function calculatePrices(subtotalAmount) {
            if (displayPrices == 'False') return;
            ajaxCall("/customapi/Configurator/CalculateTotal", { "subTotal": subtotalAmount }, null, function (response) {         
                setSummaryPrices(response.Data, subtotalAmount);
            }, function (response) {
                subtotalAmount = 0;
                setSubtotalAmount(subtotalAmount);
                alertMessage.error(response.message);
                setSummaryPrices(response.Data, subtotalAmount);                
            });
        }

        function setSummaryPrices(summaryPrices, subtotalAmount) {          
            $(".configurator-subtotal-val").text(currencyFormatter.format(subtotalAmount));
            $(".configurator-discount-val").text(discountFormatter.format(-summaryPrices.PrimaryDiscount));
            $(".configurator-sec-discount-val").text(discountFormatter.format(-summaryPrices.SecondaryDiscount));
            $(".configurator-total-val").text(summaryPrices.Total);
            $(".configurator-summary-subtotal").show();
            $(".configurator-summary-discount").show();
            $(".configurator-summary-sec-discount").show();
            $(".configurator-summary-total").show();
            if (!summaryPrices.PrimaryDiscount && !summaryPrices.SecondaryDiscount) {
                $(".configurator-summary-subtotal").hide();
                $(".configurator-summary-discount").hide();
                $(".configurator-summary-sec-discount").hide();                
            }
            else if (!summaryPrices.SecondaryDiscount)
                $(".configurator-summary-sec-discount").hide();
        }

        function handleNoneOptionClick(htmlElement) {           
            $(htmlElement).closest('table').find('input[type=checkbox]:checked, input[type=radio]:checked').each(function () {
                if ($(this).attr("id") != $(htmlElement).attr("id")) {
                    $(this).prop("checked", false);
                    clickOption($(this));
                    if ($(htmlElement).data("level") < $(this).data("level"))
                        $(this).closest("tr").remove();
                }
            });            
        }

        function groupBy(xs, key) {
            return xs.reduce(function (rv, x) {
                (rv[x[key]] = rv[x[key]] || []).push(x);
                return rv;
            }, {});
        }

        function getFormElementByProductHtmlId(productId, parentId, level, categoryId, hierarchy) {
            var selectedForm = getConfigurationForm();
            for (var i = 0; i < selectedForm.Elements.length; i++) {
                var mainCategory = selectedForm.Elements[i];
                if (productId == parentId && level == 2) {
                    if (mainCategory.HtmlId == productId) {
                        tmpOptionElement = mainCategory;
                        break;
                    }
                }
                getElementByProductHtmlId(mainCategory, productId, parentId, level, categoryId, hierarchy);
            }
        }

        function getElementByProductHtmlId(element, productId, parentId, level, categoryId, hierarchy) {
            if (!element) return;
            if (element.HtmlId == productId && element.ParentHtmlId == parentId && element.Level == level)
                if (element.HtmlId == productId && element.ParentHtmlId == parentId && element.Level == level && element.MainCategoryId == categoryId) {
                    if (hierarchy) {
                        if (element.Hierarchy == hierarchy) {
                            tmpOptionElement = element;
                            return;
                        }
                    }
                    else {
                        tmpOptionElement = element;
                        return;
                    }
                }

            if (element.Options && element.Options.length > 0) {
                for (var i = 0; i < element.Options.length; i++)
                    getElementByProductHtmlId(element.Options[i], productId, parentId, level, categoryId, hierarchy);
            }
        }

        function getExistingHtmlElement(parentElement, element) {
            var existingElement = { HtmlElement: null, SameLevel: true };
            //check if element already exists
            //if it is category, check if category exists   
            if (element.ConfigurationElementType == "Category") {
                existingElement = { HtmlElement: document.querySelector('[id^="optTable' + parentElement.HtmlId + '"][data-element-type="Category"]'), SameLevel: true };
            }
            else if (element.ConfigurationElementType == "Option") {
                existingElement = getExistingOptionItemElementOnHigherLevels(element);
            }

            return existingElement;
        }
              
        function getExistingOptionItemElementOnHigherLevels(element) {
            //check on higher levels if there is the same option 
            var existingElement = { HtmlElement: null, SameLevel: true };
            var elements = document.querySelectorAll('input[id*="element' + element.HtmlId + '"]');
            if (elements && elements.length) {
                if (elements.length == 1 && elements[0].getAttribute("data-level") == element.Level) return { HtmlElement: elements[0], SameLevel: true };
                for (var i = 0; i < elements.length; i++) {
                    var tmpElement = elements[i];
                    var level = $(tmpElement).data('level');
                    if (element.Level > level) {
                        var checked = $(tmpElement).prop("checked");
                        if (checked) {
                            var parentId = $(tmpElement).data("parentId");
                            var currentAccordion = $(tmpElement).closest(".accordion-item");
                            var groupItems = currentAccordion.find('[data-parent-id="' + parentId + '"]');
                            var groupOptionItems = [];
                            //groupitems and accordion maybe delete
                            if (groupItems && groupItems.length) {
                                for (var i = 0; i < groupItems.length; i++) {
                                    groupOptionItems.push({ Id: $(groupItems[i]).attr("id"), Level: $(groupItems[i]).data("level") });
                                }
                            }
                            existingElement = { HtmlElement: tmpElement, SameLevel: false, GroupOptionItems: groupOptionItems, Accordion: currentAccordion };
                        }
                    }
                }
            }

            return existingElement;
        }

        function setConfigurationForm(configurationForm, openAllTabs) {
            selectedData.SelectedForm = configurationForm;
            elements = '<div class="accordion open" id="accordionConfiguration">';
            var openedTabs = null;
            if (!openAllTabs)
                openedTabs = getOpenedConfigurationTabIds();

            var openedTableForOptionsWithoutCategory = false;
            $("#configurationQuantity").val(configurationForm.Quantity);
            for (var i = 0; i < configurationForm.Elements.length; i++) {
                var element = configurationForm.Elements[i];
                if (element.ConfigurationElementType == "Category" && element.Options.length > 0) {
                    closeFormOptionTableIfNeeded(openedTableForOptionsWithoutCategory);
                    openedTableForOptionsWithoutCategory = false;
                    createCategoryAccordionItem(element, openedTabs, openAllTabs);
                }
                else if (element.ConfigurationElementType == "Option") {
                    if (!openedTableForOptionsWithoutCategory) {
                        executedOnce = false;
                        openedTableForOptionsWithoutCategory = true;
                        categoryHtml = '<div class="formOptionsList">';
                    }
                    createFormOption(element);
                    if (i == configurationForm.Elements.length - 1) {
                        closeFormOptionTableIfNeeded(openedTableForOptionsWithoutCategory);
                    }
                }
            }

            elements += '</div>';
            var configurationPanel = document.getElementById('configurationPanel');
            configurationPanel.innerHTML = elements;
        }

        function closeFormOptionTableIfNeeded(openedTableForOptionsWithoutCategory) {
            if (openedTableForOptionsWithoutCategory) {
                closeCategoryTableTag();
                clearSubcategoryPlaceholder();
                categoryHtml += '</div>';
                elements += categoryHtml;
            }
        }

        function createFormOption(formOption) {
            createCategoryTable(formOption, formOption);
            createFormOptionsOnLevelOne(formOption, formOption, 1);
        }

        function addVerificationToken(payload) {
            if (document.querySelector('input[name="__RequestVerificationToken"]') !== null) {
                var token = document.querySelector('input[name="__RequestVerificationToken"]').value;
                payload.__RequestVerificationToken = token;
            }
        }

        function ajaxCall(url, payload, selector, succesFunction, errorFunction) {
            if (payload)
                addVerificationToken(payload);
            if (!selector)
                selector = ".search-overlay";
            showSpinner(selector);
            $.ajax({
                type: "POST",
                url: url,
                data: payload,
                dataType: "json",
                contentType: "application/x-www-form-urlencoded; charset=utf-8"
            }).done(function (response) {
                if (response.status === STATUS_OK) {
                    succesFunction(response);
                }
                else {
                    var message = response.Message;
                    if (!message) message = response.message;
                    console.log("ajax call: " + url + ", message: " + message);
                    if (errorFunction != null) errorFunction(response);
                }

            }).fail(function (e) {
                console.log("ajax call: " + url + ", status: " + e.Status + ", message: " + e.StatusText);
                alert("Error occured, url: " + url + ", status: " + e.Status + ", message: " + e.StatusText);

            }).always(function () {
                hideSpinner(selector);
            });
        }

        function showSpinner(selector) {
            setSpinners(selector, "block");
        }

        function setSpinners(selector, display) {
            var spinners = document.querySelectorAll(selector);
            if (spinners && spinners.length > 0) {
                for (var i = 0; i < spinners.length; i++) {
                    spinners[i].style.display = display;
                    $(spinners[i]).find(".loading-results-configurator")[0].style.display = display;
                }
            }
        }

        function hideSpinner(selector) {
            setSpinners(selector, "none");
        }

        initConfigurator();
    });
define("Configurator/main", function(){});

